import store from '../../store/index';

export default function(fieldsToSetup, methodToDispatch = 'UsedSearchOptions/updateOptions') {
    const len = fieldsToSetup.length;
    if (len == 0) {
        return [];
    }
    const computedProperties = {};
    for (let index = 0; index < len; index++) {
        computedProperties[fieldsToSetup[index]] = {
            get() {
                return store.state.UsedSearchOptions.userOptions[fieldsToSetup[index]];
            },
            set(value) {
                store.dispatch(methodToDispatch, {
                    [fieldsToSetup[index]]: value
                });
            }
        };
    }

    return computedProperties;
}


// WEBPACK FOOTER //
// ./resources/assets/js/used-vue/api/used-search-options/TwoWayComputedProperties.js